import { ROUTE_BASE } from './constants';
import { SCENE_IDS, type SceneId } from '../scenes/scene.types';

export const DEFAULT_SCENE: SceneId = 'hall';

function isSceneId(value: string): value is SceneId {
  return (SCENE_IDS as readonly string[]).includes(value);
}

/**
 * `/boutique`, `/boutique/` et une scène inconnue retombent sur le Hall.
 * Toute autre URL renvoie null : ce n'est pas notre périmètre.
 */
export function sceneFromPath(pathname: string): SceneId | null {
  const clean = pathname.replace(/\/+$/, '');
  if (clean === ROUTE_BASE || clean === '') return DEFAULT_SCENE;
  if (!clean.startsWith(`${ROUTE_BASE}/`)) return null;
  const segment = clean.slice(ROUTE_BASE.length + 1);
  if (segment.includes('/')) return null;
  return isSceneId(segment) ? segment : DEFAULT_SCENE;
}

export function pathForScene(sceneId: SceneId): string {
  return `${ROUTE_BASE}/${sceneId}`;
}

type RouteListener = (sceneId: SceneId) => void;

let listener: RouteListener | null = null;
let current: SceneId = DEFAULT_SCENE;

export function currentScene(): SceneId {
  return current;
}

/** Navigation interne : pousse une entrée d'historique et notifie l'application. */
export function navigate(sceneId: SceneId, options: { replace?: boolean } = {}): void {
  const path = pathForScene(sceneId);
  if (options.replace) {
    window.history.replaceState({ sceneId }, '', path);
  } else if (sceneId !== current || window.location.pathname !== path) {
    window.history.pushState({ sceneId }, '', path);
  }
  current = sceneId;
  listener?.(sceneId);
}

export function startRouter(onChange: RouteListener): void {
  listener = onChange;
  const initial = sceneFromPath(window.location.pathname) ?? DEFAULT_SCENE;
  navigate(initial, { replace: true });

  window.addEventListener('popstate', () => {
    const next = sceneFromPath(window.location.pathname) ?? DEFAULT_SCENE;
    current = next;
    listener?.(next);
  });
}
